export class ChangePinsParams {
  currentPin: string
  pin: string
  resetPin: string

  constructor({ currentPin, pin, resetPin }: { currentPin: string, pin: string, resetPin: string }) {
    this.currentPin = currentPin
    this.pin = pin
    this.resetPin = resetPin
  }
}
